import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('authtoken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        localStorage.removeItem('authtoken');
    }

    return result;
};

export const VideosApi = createApi({
    reducerPath: 'VideosApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getVideos: builder.query({
              query: (param) => ({
                url: `/videos/get-videos/`,
                method: 'Get',
                params: param
            })
        }),
        postVideos: builder.mutation({
            query: (data) => ({
                url: `/videos/create-video/`,
                method: "POST",
                body: data
            })
        }),
        updateVideo: builder.mutation({
            query: ({ id, data }) => {
                   return {
                    url: `/videos/edit-video/${id}/`,
                    method: "PUT",
                    body: data,
                    // Note: Content-Type is automatically set when sending FormData, so no need to set it manually
                };
            },
        }),
        deleteVideo: builder.mutation({
            query: (id) => {
              return {
                url: `/videos/delete-video/${id}/`,
                method: "DELETE",
              };
            },
          }),


    }),

});

export const { useGetVideosQuery, usePostVideosMutation, useUpdateVideoMutation, useDeleteVideoMutation} = VideosApi; 
